export default __webpack_public_path__ + "static/media/file-unknown.1a93dc93.svg";